import { TBtn } from '../primitives';
import { useCartContext } from './index';

export function CartFooter() {
    const { items, totalCost, totalQty, T, generating, onClear, onConfirm, setConfirmed } = useCartContext();
    return (
        <div
            style={{
                padding: '16px 20px',
                borderTop: `1px solid ${T.line}`,
                background: T.bgSoft,
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 12, color: T.muted, marginBottom: 3 }}>
                        {items.length} SKU{items.length !== 1 ? 's' : ''} · {totalQty} unidades
                    </div>
                    <div
                        style={{
                            fontSize: 16,
                            fontWeight: 600,
                            fontFamily: T.mono,
                            color: T.ink,
                            whiteSpace: 'nowrap',
                        }}
                    >
                        R$ {totalCost.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                        <span style={{ fontSize: 11, fontWeight: 400, color: T.muted, marginLeft: 6 }}>
                            custo estimado
                        </span>
                    </div>
                </div>

                <TBtn variant="ghost" size="sm" onClick={onClear} style={{ color: T.danger }}>
                    limpar
                </TBtn>
                <TBtn
                    variant="primary"
                    size="md"
                    disabled={generating}
                    onClick={async () => {
                        if (onConfirm) {
                            const ok = await onConfirm();
                            if (ok) setConfirmed(true);
                        } else {
                            setConfirmed(true);
                        }
                    }}
                    data-faid="Generate_OC_Button_Cart_Modal"
                >
                    {generating ? 'Gerando...' : 'Gerar OC'}
                </TBtn>
            </div>
        </div>
    );
}
